import classNames from "classnames";
import React from "react";
import { connectRefinementList } from "react-instantsearch-dom";

const RefinementList = ({ items, refine }) => (
	<>
		{items.map((item) => (
			<button
				key={item.label}
				onClick={() => refine(item.value)}
				className={classNames("mb-1 me-1 btn btn-sm", {
					"btn-success text-white": item.isRefined,
					"btn-outline-secondary": !item.isRefined,
				})}
			>
				{item.label}
			</button>
		))}
	</>
);

export default connectRefinementList(RefinementList);
